module.exports = __webpack_public_path__ + "operace-ocnich-vicek-horni_5_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/operace-ocnich-vicek-horni_5_after_tn.jpg
// module id = 1633
// module chunks = 0